function extractGoogleDriveId(link) {
  if (!link) {
    return null;
  }

  const trimmed = String(link).trim();
  if (!trimmed) {
    return null;
  }

  if (/^[a-zA-Z0-9_-]{20,}$/.test(trimmed)) {
    return trimmed;
  }

  const patterns = [
    /drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/,
    /drive\.google\.com\/open\?id=([a-zA-Z0-9_-]+)/,
    /drive\.google\.com\/thumbnail\?id=([a-zA-Z0-9_-]+)/,
    /docs\.google\.com\/uc\?.*id=([a-zA-Z0-9_-]+)/,
    /drive\.google\.com\/uc\?.*id=([a-zA-Z0-9_-]+)/
  ];

  for (const pattern of patterns) {
    const match = trimmed.match(pattern);
    if (match?.[1]) {
      return match[1];
    }
  }

  try {
    const url = new URL(trimmed);
    const idFromQuery = url.searchParams.get("id");
    if (idFromQuery) {
      return idFromQuery;
    }
  } catch (error) {
    return null;
  }

  return null;
}

export function isGoogleDriveLink(link) {
  if (!link) {
    return false;
  }

  const value = String(link).toLowerCase();
  return (
    value.includes("drive.google.com")
    || value.includes("docs.google.com")
    || value.includes("googleusercontent.com")
  );
}

export function resolveImageUrlCandidates(link) {
  if (!link) {
    return [];
  }

  const trimmed = String(link).trim();
  if (!trimmed) {
    return [];
  }

  const driveId = extractGoogleDriveId(trimmed);
  if (!driveId || !isGoogleDriveLink(trimmed)) {
    return [trimmed];
  }

  const candidates = [
    `https://lh3.googleusercontent.com/d/${driveId}=w1200`,
    `https://drive.google.com/thumbnail?id=${driveId}&sz=w1200`,
    `https://drive.google.com/uc?export=view&id=${driveId}`,
    `https://drive.google.com/uc?id=${driveId}`,
    `https://docs.google.com/uc?id=${driveId}&export=download`,
    trimmed
  ];

  return [...new Set(candidates)];
}

export function toGoogleDrivePreviewUrl(link) {
  return resolveImageUrlCandidates(link)[0] || null;
}

export function resolveImageUrl(link) {
  return resolveImageUrlCandidates(link)[0] || "";
}

export function getInitials(name) {
  if (!name) {
    return "NA";
  }
  const words = name.trim().split(/\s+/).slice(0, 2);
  return words.map((word) => word[0]?.toUpperCase() || "").join("") || "NA";
}
